export const API_URL = process.env.REACT_APP_BASE_URL
export const TABLE_ROW_ACTIONS  = {
    favorite : "favorite",
    archive : "archive",
    multipleSelection : "multipleSelection",
}
